import { render, staticRenderFns } from "./PhoneOut.vue?vue&type=template&id=0aefa84e&"
import script from "./PhoneOut.vue?vue&type=script&lang=js&"
export * from "./PhoneOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports